<template>
    
    <div class="visual_afleverskid_byk">

        <svg version="1.1" id="Laag_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
            viewBox="0 0 595.3 212" style="enable-background:new 0 0 595.28 212;" xml:space="preserve">

        <rect x="464.7" y="26.5" class="st0" width="98" height="142.1"/>
        <path v-if="flame" class="st1" d="M494.5,160.9c-4.1-4.7-8.2-9.5-10.8-15.3c-2.6-6.2-3.4-13.2-2-20s4.3-13.1,8.6-18.5c-0.4,4.7,1.3,9.5,4.5,13.1
            c-1.9-9,1.1-18.7,7.1-25.8c6-7.1,14.2-11.8,22.8-14.9c-4.3,4.5-4.8,11.6-3.2,17.5c1.7,6,5.2,11.2,8.4,16.6c3.2,5.4,6.2,11,6.3,17.2
            c1.7-3.2,3.5-6.3,4.7-9.9c1.1-3.6,1.7-7.3,0.8-10.8c3.4,4.1,5.2,8.2,6.2,13.4c0.9,5.2,0.8,10.6,0.2,15.9c-0.8,5.8-2.2,11.8-5.4,16.6
            c-3.7,5.8-9.7,9.9-16.2,12.1C514.6,170.2,503.2,168.6,494.5,160.9z"/>
        <path v-if="flame" class="st2" d="M508.7,167.8c15.3,6,30.4-12.1,22-26.1c0-0.2-0.2-0.2-0.2-0.4c0.8,7.6-1.1,13.2-4.7,16.4
            c1.9-4.5,0.6-9.7-1.7-14.2c-2.2-4.3-5.4-8.2-7.8-12.3c-2.4-4.3-4.3-9.2-3.2-14c-4.5,3.4-7.6,8.4-9,13.8c-1.3,5.4-0.6,11.4,1.9,16.4
            c-2.8-2.1-4.9-5.4-5-9c-3,3.6-4.9,8.2-4.7,12.9C496.3,158.7,502.1,165.2,508.7,167.8z"/>
        <rect x="488.1" y="168.6" class="st0" width="53" height="17.9"/>
        <line class="st3" x1="136.1" y1="178.1" x2="488.1" y2="178.1"/>
        <line class="st3" x1="31.2" y1="178.1" x2="93.2" y2="178.1"/>
        <path d="M136.1,171.6h-8.7c-0.3-0.9-1.1-1.4-2-1.4s-1.7,0.6-2,1.4h-2.3v-2.3c1-0.4,1.6-1.4,1.4-2.4c-0.2-1-1.1-1.8-2.1-1.8h-2.9
            v-1.4h1.4c0.4,0,0.7-0.3,0.7-0.7v-2.1h4.3c1.2,0,2.1-1,2.1-2.1s-1-2.1-2.1-2.1h-18.6c-1.2,0-2.1,1-2.1,2.1s1,2.1,2.1,2.1h4.3v2.1
            c0,0.4,0.3,0.7,0.7,0.7h1.4v1.4h-2.9c-1.2,0-2.1,1-2.1,2.1c0,0.9,0.6,1.7,1.4,2v2.3H106c-0.3-0.9-1.1-1.4-2-1.4
            c-0.9,0-1.7,0.6-2,1.4h-8.7v12.9h8.7c0.3,0.9,1.1,1.4,2,1.4s1.7-0.6,2-1.4h17.4c0.3,0.9,1.1,1.4,2,1.4c0.9,0,1.7-0.6,2-1.4h8.7
            L136.1,171.6L136.1,171.6z M104.6,158.7c0-0.4,0.3-0.7,0.7-0.7h18.6c0.4,0,0.7,0.3,0.7,0.7s-0.3,0.7-0.7,0.7h-18.6
            C104.9,159.5,104.6,159.1,104.6,158.7z M111.1,160.9h7.1v1.4h-7.1V160.9z M113.2,163.7h2.9v1.4h-2.9V163.7z M108.4,166.8
            c0.1-0.1,0.3-0.2,0.5-0.2h11.4c0.4,0,0.7,0.3,0.7,0.7s-0.3,0.7-0.7,0.7h-11.4c-0.4,0-0.7-0.3-0.7-0.7
            C108.2,167.1,108.3,166.9,108.4,166.8z M94.6,173h7.1v10h-7.1V173z M103.9,184.5c-0.4,0-0.7-0.3-0.7-0.7v-11.4
            c0-0.2,0.1-0.4,0.2-0.5c0.1-0.1,0.3-0.2,0.5-0.2c0.4,0,0.7,0.3,0.7,0.7v11.4C104.6,184.1,104.3,184.5,103.9,184.5z M106.1,173h2.9
            c0.4,0,0.7-0.3,0.7-0.7v-2.9h10v2.9c0,0.4,0.3,0.7,0.7,0.7h2.9v10H106L106.1,173L106.1,173z M125.3,184.5c-0.4,0-0.7-0.3-0.7-0.7
            v-11.4c0-0.4,0.3-0.7,0.7-0.7s0.7,0.3,0.7,0.7v11.4c0,0.2-0.1,0.4-0.2,0.5C125.7,184.4,125.5,184.5,125.3,184.5z M134.6,183h-7.1
            v-10h7.1V183z"/>
        <line class="st3" x1="177" y1="178" x2="177" y2="167.2"/>
        <circle class="st3" cx="177" cy="155.5" r="11.7"/>
        <rect x="194.9" y="147.7" class="st3" width="35.3" height="14.4"/>
        <rect x="198.4" y="151.9" class="st4" width="29.6" height="8.1"/>
        <text transform="matrix(1 0 0 1 198.3584 157.5293)" class="st5 st6">{{ afleverdruk }}</text>
        <g>
            <path d="M235.8,154.4c0-0.5,0-0.8,0-1.2h0.7l0,0.7h0c0.2-0.4,0.7-0.8,1.4-0.8c0.6,0,1.1,0.4,1.3,0.9h0c0.1-0.2,0.3-0.4,0.5-0.6
                c0.3-0.2,0.6-0.3,1-0.3c0.6,0,1.5,0.4,1.5,1.9v2.6h-0.8v-2.5c0-0.9-0.3-1.4-1-1.4c-0.5,0-0.8,0.3-1,0.7c0,0.1-0.1,0.3-0.1,0.4v2.8
                h-0.8v-2.7c0-0.7-0.3-1.2-0.9-1.2c-0.5,0-0.9,0.4-1,0.8c-0.1,0.1-0.1,0.3-0.1,0.4v2.7h-0.8L235.8,154.4L235.8,154.4z"/>
            <path d="M245.4,157.7c0-0.3,0-0.8,0-1.1v-5.4h0.8v2.8h0c0.3-0.5,0.8-0.8,1.5-0.8c1.1,0,1.9,0.9,1.9,2.3c0,1.6-1,2.4-2,2.4
                c-0.6,0-1.2-0.2-1.5-0.8h0l0,0.7L245.4,157.7L245.4,157.7z M246.3,155.9c0,0.1,0,0.2,0,0.3c0.2,0.6,0.6,0.9,1.2,0.9
                c0.9,0,1.4-0.7,1.4-1.7c0-0.9-0.5-1.7-1.3-1.7c-0.6,0-1.1,0.4-1.2,1c0,0.1-0.1,0.2-0.1,0.3L246.3,155.9L246.3,155.9z"/>
            <path d="M253.2,157.7l-0.1-0.6h0c-0.2,0.4-0.7,0.7-1.4,0.7c-0.9,0-1.4-0.6-1.4-1.3c0-1.1,1-1.7,2.7-1.7v-0.1c0-0.4-0.1-1-1-1
                c-0.4,0-0.9,0.1-1.2,0.3l-0.2-0.5c0.4-0.2,0.9-0.4,1.5-0.4c1.4,0,1.7,0.9,1.7,1.8v1.7c0,0.4,0,0.8,0.1,1.1L253.2,157.7L253.2,157.7
                z M253.1,155.4c-0.9,0-1.9,0.1-1.9,1c0,0.5,0.4,0.8,0.8,0.8c0.6,0,0.9-0.4,1.1-0.8c0-0.1,0.1-0.2,0.1-0.3V155.4z"/>
            <path d="M255.2,154.6c0-0.5,0-1,0-1.4h0.7l0,0.9h0c0.2-0.6,0.7-1,1.2-1c0.1,0,0.2,0,0.2,0v0.8c-0.1,0-0.2,0-0.3,0
                c-0.6,0-1,0.4-1.1,1c0,0.1,0,0.2,0,0.4v2.4h-0.8L255.2,154.6L255.2,154.6z"/>
        </g>
        <line class="st3" x1="280.3" y1="178.1" x2="280.3" y2="167.3"/>
        <circle class="st3" cx="280.3" cy="155.6" r="11.7"/>
        <rect x="298.2" y="147.7" class="st3" width="35.3" height="14.4"/>
        <rect x="301.7" y="151.9" class="st4" width="29.6" height="8.1"/>
        <text transform="matrix(1 0 0 1 301.6913 157.5702)" class="st5 st6">{{ temprature }}</text>
        <g>
            <path d="M341.2,152.6c0,0.8-0.6,1.2-1.2,1.2c-0.7,0-1.2-0.5-1.2-1.2c0-0.7,0.5-1.2,1.2-1.2C340.8,151.4,341.2,152,341.2,152.6z
                M339.3,152.7c0,0.4,0.3,0.8,0.7,0.8c0.4,0,0.7-0.3,0.7-0.8c0-0.3-0.2-0.8-0.7-0.8C339.5,151.9,339.3,152.3,339.3,152.7z"/>
            <path d="M346.5,157.6c-0.3,0.1-0.9,0.3-1.6,0.3c-1.8,0-3.1-1.1-3.1-3.1c0-1.9,1.3-3.3,3.2-3.3c0.8,0,1.3,0.2,1.5,0.3l-0.2,0.6
                c-0.3-0.1-0.7-0.3-1.2-0.3c-1.5,0-2.4,0.9-2.4,2.6c0,1.5,0.9,2.5,2.4,2.5c0.5,0,1-0.1,1.3-0.3L346.5,157.6z"/>
        </g>
        <line class="st3" x1="373.5" y1="178.1" x2="373.5" y2="167.3"/>
        <circle class="st3" cx="373.5" cy="155.6" r="11.7"/>
        <rect x="391.4" y="147.8" class="st3" width="35.3" height="14.4"/>
        <rect x="394.9" y="151.9" class="st4" width="29.6" height="8.1"/>
        <text transform="matrix(1 0 0 1 394.9186 157.6111)" class="st5 st6">{{ flow }}</text>
        <g>
            <path d="M432.4,154.5c0-0.5,0-0.8,0-1.2h0.7l0,0.7h0c0.2-0.4,0.7-0.8,1.4-0.8c0.6,0,1.1,0.4,1.3,0.9h0c0.1-0.2,0.3-0.4,0.5-0.6
                c0.3-0.2,0.6-0.3,1-0.3c0.6,0,1.5,0.4,1.5,1.9v2.6H438v-2.5c0-0.9-0.3-1.4-1-1.4c-0.5,0-0.8,0.3-1,0.7c0,0.1-0.1,0.3-0.1,0.4v2.8
                h-0.8v-2.7c0-0.7-0.3-1.2-0.9-1.2c-0.5,0-0.9,0.4-1,0.8c0,0.1-0.1,0.3-0.1,0.4v2.7h-0.8L432.4,154.5L432.4,154.5z"/>
            <path d="M439.7,150.4c0.2-0.1,0.6-0.3,1.1-0.3c0.8,0,1.1,0.4,1.1,0.9c0,0.4-0.3,0.7-0.7,0.8v0c0.5,0.1,0.9,0.4,0.9,0.9
                c0,0.6-0.5,1.1-1.5,1.1c-0.4,0-0.9-0.1-1-0.2l0.2-0.5c0.1,0.1,0.5,0.2,0.9,0.2c0.6,0,0.8-0.3,0.8-0.6c0-0.5-0.5-0.6-1-0.6h-0.2
                v-0.4h0.3c0.3,0,0.8-0.2,0.8-0.6c0-0.2-0.2-0.5-0.6-0.5c-0.3,0-0.6,0.1-0.8,0.2L439.7,150.4z"/>
            <path d="M444.2,158.2l2.6-6.7h0.6l-2.6,6.7H444.2z"/>
            <path d="M453.7,156.6c0,0.5,0,0.9,0,1.2H453l0-0.7h0c-0.2,0.4-0.7,0.8-1.5,0.8c-0.7,0-1.5-0.4-1.5-1.9v-2.6h0.8v2.5
                c0,0.9,0.3,1.4,1,1.4c0.5,0,0.9-0.4,1.1-0.7c0-0.1,0.1-0.3,0.1-0.4v-2.7h0.8L453.7,156.6L453.7,156.6z"/>
        </g>
        <rect x="31.2" y="150.8" class="st3" width="35.3" height="14.4"/>
        <rect x="34.7" y="155" class="st4" width="29.6" height="8.1"/>
        <text transform="matrix(1 0 0 1 34.6622 160.6766)" class="st5 st6">{{ buffer_gas }}</text>
        <g>
            <path d="M30.9,135.7c0.3-0.1,0.8-0.1,1.3-0.1c0.7,0,1.1,0.1,1.5,0.4c0.3,0.2,0.5,0.5,0.5,0.9c0,0.5-0.3,1-0.9,1.2v0
                c0.5,0.1,1.1,0.6,1.1,1.4c0,0.5-0.2,0.8-0.5,1.1c-0.4,0.3-1,0.5-1.9,0.5c-0.5,0-0.9,0-1.1-0.1V135.7z M31.5,137.9h0.6
                c0.7,0,1.2-0.4,1.2-0.9c0-0.6-0.5-0.9-1.2-0.9c-0.3,0-0.5,0-0.6,0.1C31.5,136.2,31.5,137.9,31.5,137.9z M31.5,140.5
                c0.1,0,0.3,0,0.6,0c0.7,0,1.4-0.3,1.4-1.1c0-0.7-0.6-1-1.4-1h-0.6L31.5,140.5L31.5,140.5z"/>
            <path d="M38.4,139.9c0,0.4,0,0.8,0,1.1h-0.6l0-0.6h0c-0.2,0.3-0.6,0.7-1.3,0.7c-0.6,0-1.3-0.3-1.3-1.7v-2.3h0.7v2.1
                c0,0.7,0.2,1.2,0.9,1.2c0.5,0,0.8-0.3,0.9-0.6c0-0.1,0.1-0.2,0.1-0.4v-2.4h0.7L38.4,139.9L38.4,139.9z"/>
            <path d="M42,141v-3.3h-1.6v3.3h-0.7v-3.3h-0.5v-0.5h0.5V137c0-0.5,0.1-1,0.4-1.3c0.2-0.2,0.5-0.4,1-0.4c0.2,0,0.4,0.1,0.5,0.1
                l-0.1,0.5c-0.1-0.1-0.3-0.1-0.4-0.1c-0.5,0-0.7,0.5-0.7,1.1v0.2H42v-0.2c0-0.5,0.1-1,0.5-1.4c0.3-0.3,0.6-0.4,0.9-0.4
                c0.3,0,0.5,0.1,0.6,0.1l-0.1,0.5c-0.1-0.1-0.2-0.1-0.5-0.1c-0.6,0-0.8,0.5-0.8,1.1v0.2h0.9v0.5h-0.9v3.3L42,141L42,141z"/>
            <path d="M44.5,139.2c0,0.9,0.6,1.3,1.3,1.3c0.5,0,0.8-0.1,1.1-0.2l0.1,0.5c-0.2,0.1-0.7,0.2-1.3,0.2c-1.2,0-1.9-0.8-1.9-1.9
                s0.7-2.1,1.8-2.1c1.3,0,1.6,1.1,1.6,1.8c0,0.1,0,0.3,0,0.3L44.5,139.2L44.5,139.2z M46.6,138.7c0-0.4-0.2-1.1-1-1.1
                c-0.7,0-1,0.7-1.1,1.1H46.6z"/>
            <path d="M48.1,138.3c0-0.5,0-0.9,0-1.2h0.6l0,0.8h0c0.2-0.5,0.6-0.9,1.1-0.9c0.1,0,0.1,0,0.2,0v0.7c-0.1,0-0.1,0-0.2,0
                c-0.5,0-0.8,0.4-0.9,0.9c0,0.1,0,0.2,0,0.3v2.1h-0.7V138.3z"/>
            <path d="M51.2,137.1l0.8,2.2c0.1,0.4,0.2,0.7,0.3,1h0c0.1-0.3,0.2-0.6,0.3-1l0.8-2.2h0.7l-1.5,3.9H52l-1.5-3.9H51.2z"/>
            <path d="M58.2,139c0,1.4-1,2.1-1.9,2.1c-1,0-1.8-0.8-1.8-2c0-1.3,0.8-2.1,1.9-2.1C57.5,137,58.2,137.8,58.2,139z M55.2,139.1
                c0,0.9,0.5,1.5,1.2,1.5c0.7,0,1.2-0.6,1.2-1.5c0-0.7-0.3-1.5-1.2-1.5C55.5,137.6,55.2,138.3,55.2,139.1z"/>
            <path d="M62.6,139c0,1.4-1,2.1-1.9,2.1c-1,0-1.8-0.8-1.8-2c0-1.3,0.8-2.1,1.9-2.1C61.9,137,62.6,137.8,62.6,139z M59.5,139.1
                c0,0.9,0.5,1.5,1.2,1.5c0.7,0,1.2-0.6,1.2-1.5c0-0.7-0.3-1.5-1.2-1.5C59.9,137.6,59.5,138.3,59.5,139.1z"/>
            <path d="M63.5,138.3c0-0.5,0-0.9,0-1.2h0.6l0,0.8h0c0.2-0.5,0.6-0.9,1.1-0.9c0.1,0,0.1,0,0.2,0v0.7c-0.1,0-0.1,0-0.2,0
                c-0.5,0-0.8,0.4-0.9,0.9c0,0.1,0,0.2,0,0.3v2.1h-0.7C63.5,141,63.5,138.3,63.5,138.3z"/>
            <path d="M66.2,138.3c0-0.5,0-0.9,0-1.2h0.6l0,0.8h0c0.2-0.5,0.6-0.9,1.1-0.9c0.1,0,0.1,0,0.2,0v0.7c-0.1,0-0.1,0-0.2,0
                c-0.5,0-0.8,0.4-0.9,0.9c0,0.1,0,0.2,0,0.3v2.1h-0.7V138.3z"/>
            <path d="M70.9,141l-0.1-0.5h0c-0.2,0.3-0.6,0.6-1.2,0.6c-0.8,0-1.2-0.6-1.2-1.1c0-0.9,0.8-1.4,2.3-1.4v-0.1c0-0.3-0.1-0.9-0.9-0.9
                c-0.4,0-0.7,0.1-1,0.3l-0.2-0.5c0.3-0.2,0.8-0.3,1.3-0.3c1.2,0,1.5,0.8,1.5,1.6v1.4c0,0.3,0,0.7,0.1,0.9L70.9,141L70.9,141z
                M70.8,139c-0.8,0-1.6,0.1-1.6,0.9c0,0.5,0.3,0.7,0.7,0.7c0.5,0,0.8-0.3,0.9-0.6c0-0.1,0-0.1,0-0.2C70.8,139.7,70.8,139,70.8,139z"
                />
            <path d="M74.7,141l-0.1-0.5h0c-0.2,0.3-0.6,0.6-1.2,0.6c-0.8,0-1.2-0.6-1.2-1.1c0-0.9,0.8-1.4,2.3-1.4v-0.1c0-0.3-0.1-0.9-0.9-0.9
                c-0.4,0-0.7,0.1-1,0.3l-0.2-0.5c0.3-0.2,0.8-0.3,1.3-0.3c1.2,0,1.5,0.8,1.5,1.6v1.4c0,0.3,0,0.7,0.1,0.9L74.7,141L74.7,141z
                M74.6,139c-0.8,0-1.6,0.1-1.6,0.9c0,0.5,0.3,0.7,0.7,0.7c0.5,0,0.8-0.3,0.9-0.6c0-0.1,0-0.1,0-0.2C74.6,139.7,74.6,139,74.6,139z"
                />
            <path d="M79.8,135.3v4.7c0,0.3,0,0.7,0,1h-0.6l0-0.7h0c-0.2,0.4-0.7,0.8-1.3,0.8c-0.9,0-1.7-0.8-1.7-2c0-1.3,0.8-2.1,1.7-2.1
                c0.6,0,1,0.3,1.2,0.6h0v-2.3L79.8,135.3L79.8,135.3z M79.1,138.7c0-0.1,0-0.2,0-0.3c-0.1-0.4-0.5-0.8-1-0.8c-0.7,0-1.2,0.6-1.2,1.5
                c0,0.8,0.4,1.4,1.1,1.4c0.5,0,0.9-0.3,1-0.8c0-0.1,0-0.2,0-0.3L79.1,138.7L79.1,138.7z"/>
        </g>
        <rect x="30.2" y="43.3" class="st3" width="180.1" height="65.1"/>
        <g>
            <path d="M35.1,35.2c-0.3,0.1-0.9,0.3-1.7,0.3c-0.8,0-1.5-0.2-2-0.7c-0.5-0.5-0.8-1.2-0.8-2c0-1.6,1.1-2.8,2.9-2.8
                c0.6,0,1.1,0.1,1.3,0.2l-0.2,0.6c-0.3-0.1-0.7-0.2-1.2-0.2c-1.3,0-2.2,0.8-2.2,2.2c0,1.4,0.8,2.2,2.1,2.2c0.5,0,0.8-0.1,0.9-0.1
                v-1.6h-1.1v-0.6h1.8L35.1,35.2L35.1,35.2z"/>
            <path d="M38.4,35.4l-0.1-0.5h0c-0.2,0.3-0.6,0.6-1.2,0.6c-0.8,0-1.2-0.5-1.2-1.1c0-0.9,0.8-1.5,2.3-1.4v-0.1c0-0.3-0.1-0.9-0.9-0.9
                c-0.4,0-0.7,0.1-1,0.3l-0.2-0.5c0.3-0.2,0.8-0.3,1.3-0.3c1.2,0,1.5,0.8,1.5,1.6v1.5c0,0.3,0,0.7,0.1,0.9L38.4,35.4L38.4,35.4z
                M38.3,33.5c-0.8,0-1.6,0.1-1.6,0.9c0,0.5,0.3,0.7,0.7,0.7c0.5,0,0.8-0.3,0.9-0.7c0-0.1,0-0.2,0-0.2V33.5z"/>
            <path d="M40,34.7c0.2,0.1,0.6,0.3,0.9,0.3c0.5,0,0.8-0.3,0.8-0.6c0-0.3-0.2-0.5-0.7-0.7c-0.7-0.2-1-0.6-1-1.1
                c0-0.6,0.5-1.1,1.3-1.1c0.4,0,0.7,0.1,1,0.2L42,32.2c-0.1-0.1-0.4-0.2-0.8-0.2c-0.4,0-0.7,0.2-0.7,0.5c0,0.3,0.2,0.5,0.7,0.7
                c0.7,0.3,1,0.6,1,1.2c0,0.7-0.5,1.2-1.5,1.2c-0.4,0-0.8-0.1-1.1-0.3L40,34.7z"/>
            <path d="M45.4,35.4l-0.1-0.5h0c-0.2,0.3-0.6,0.6-1.2,0.6c-0.8,0-1.2-0.5-1.2-1.1c0-0.9,0.8-1.5,2.3-1.4v-0.1c0-0.3-0.1-0.9-0.9-0.9
                c-0.4,0-0.7,0.1-1,0.3l-0.2-0.5c0.3-0.2,0.8-0.3,1.3-0.3c1.2,0,1.5,0.8,1.5,1.6v1.5c0,0.3,0,0.7,0.1,0.9L45.4,35.4L45.4,35.4z
                M45.3,33.5c-0.8,0-1.6,0.1-1.6,0.9c0,0.5,0.3,0.7,0.7,0.7c0.5,0,0.8-0.3,0.9-0.7c0-0.1,0-0.2,0-0.2V33.5z"/>
            <path d="M47.1,32.6c0-0.4,0-0.7,0-1h0.6l0,0.6h0c0.2-0.4,0.6-0.7,1.3-0.7c0.5,0,1.4,0.3,1.4,1.7v2.3h-0.7v-2.2
                c0-0.6-0.2-1.1-0.9-1.1c-0.5,0-0.8,0.3-0.9,0.7c0,0.1,0,0.2,0,0.3v2.3h-0.7L47.1,32.6L47.1,32.6z"/>
            <path d="M53.7,35.4l-0.1-0.5h0c-0.2,0.3-0.6,0.6-1.2,0.6c-0.8,0-1.2-0.5-1.2-1.1c0-0.9,0.8-1.5,2.3-1.4v-0.1c0-0.3-0.1-0.9-0.9-0.9
                c-0.4,0-0.7,0.1-1,0.3l-0.2-0.5c0.3-0.2,0.8-0.3,1.3-0.3c1.2,0,1.5,0.8,1.5,1.6v1.5c0,0.3,0,0.7,0.1,0.9L53.7,35.4L53.7,35.4z
                M53.6,33.5c-0.8,0-1.6,0.1-1.6,0.9c0,0.5,0.3,0.7,0.7,0.7c0.5,0,0.8-0.3,0.9-0.7c0-0.1,0-0.2,0-0.2V33.5z"/>
            <path d="M55.4,29.8h0.7v5.7h-0.7V29.8z"/>
            <path d="M57.5,31.6l0.8,2.3c0.1,0.3,0.2,0.6,0.2,0.8h0c0.1-0.2,0.2-0.5,0.2-0.8l0.8-2.3h0.7l-1.1,2.8c-0.5,1.3-0.8,2-1.3,2.4
                c-0.3,0.3-0.7,0.4-0.9,0.5L57,36.6c0.2-0.1,0.4-0.2,0.6-0.3c0.2-0.2,0.4-0.4,0.6-0.8c0-0.1,0.1-0.1,0.1-0.2s0-0.1,0-0.2l-1.4-3.6
                L57.5,31.6L57.5,31.6z"/>
            <path d="M60.9,34.7c0.2,0.1,0.6,0.3,0.9,0.3c0.5,0,0.8-0.3,0.8-0.6c0-0.3-0.2-0.5-0.7-0.7c-0.7-0.2-1-0.6-1-1.1
                c0-0.6,0.5-1.1,1.3-1.1c0.4,0,0.7,0.1,1,0.2L63,32.2c-0.2-0.1-0.4-0.2-0.8-0.2c-0.4,0-0.7,0.2-0.7,0.5c0,0.3,0.2,0.5,0.7,0.7
                c0.7,0.3,1,0.6,1,1.2c0,0.7-0.5,1.2-1.5,1.2c-0.4,0-0.8-0.1-1.1-0.3L60.9,34.7z"/>
            <path d="M64.6,33.6c0,1,0.6,1.3,1.3,1.3c0.5,0,0.8-0.1,1.1-0.2l0.1,0.5c-0.2,0.1-0.7,0.2-1.3,0.2c-1.2,0-1.9-0.8-1.9-2
                c0-1.2,0.7-2.1,1.8-2.1c1.3,0,1.6,1.1,1.6,1.8c0,0.1,0,0.3,0,0.3L64.6,33.6L64.6,33.6z M66.6,33.1c0-0.5-0.2-1.1-1-1.1
                c-0.7,0-1,0.7-1.1,1.1H66.6z"/>
        </g>
        <rect x="41.8" y="57.8" class="st3" width="35.3" height="14.4"/>
        <rect x="45.3" y="62" class="st4" width="29.6" height="8.1"/>
        <text transform="matrix(1 0 0 1 45.3124 67.6386)" class="st5 st6">{{ ch4 }}</text>
        <g>
            <path d="M87.2,67.6c-0.3,0.2-0.9,0.3-1.6,0.3c-1.8,0-3.1-1.1-3.1-3.1c0-1.9,1.3-3.3,3.2-3.3c0.8,0,1.3,0.2,1.5,0.3L87,62.4
                c-0.3-0.2-0.7-0.3-1.2-0.3c-1.5,0-2.4,0.9-2.4,2.6c0,1.5,0.9,2.5,2.4,2.5c0.5,0,1-0.1,1.3-0.3L87.2,67.6z"/>
            <path d="M89,61.6v2.6h3v-2.6h0.8v6.2H92v-2.9h-3v2.9h-0.8v-6.2H89z"/>
            <path d="M96.4,67.8v-1.6h-2.8v-0.5l2.7-3.8h0.9v3.7H98v0.6h-0.8v1.6L96.4,67.8L96.4,67.8z M96.4,65.6v-2c0-0.3,0-0.6,0-0.9h0
                c-0.2,0.3-0.3,0.6-0.5,0.9l-1.5,2v0H96.4z"/>
        </g>
        <rect x="42.4" y="82.2" class="st3" width="35.3" height="14.4"/>
        <rect x="45.9" y="86.3" class="st4" width="29.6" height="8.1"/>
        <text transform="matrix(1 0 0 1 45.8549 92.0324)" class="st5 st6">{{ h2s }}</text>
        <g>
            <path d="M84.2,86v2.6h3V86H88v6.2h-0.8v-2.9h-3v2.9h-0.8V86H84.2z"/>
            <path d="M89.1,92.2v-0.5l0.6-0.6c1.5-1.5,2.2-2.2,2.2-3.1c0-0.6-0.3-1.2-1.2-1.2c-0.5,0-1,0.3-1.3,0.5l-0.3-0.6
                c0.4-0.3,1-0.6,1.7-0.6c1.3,0,1.8,0.9,1.8,1.7c0,1.1-0.8,2-2.1,3.2l-0.5,0.4v0h2.7v0.7H89.1z"/>
            <path d="M94,91.2c0.4,0.2,0.9,0.4,1.4,0.4c0.8,0,1.3-0.4,1.3-1.1c0-0.6-0.3-0.9-1.2-1.2c-1-0.4-1.6-0.9-1.6-1.8c0-1,0.8-1.7,2-1.7
                c0.6,0,1.1,0.2,1.4,0.3l-0.2,0.7c-0.2-0.1-0.6-0.3-1.2-0.3c-0.8,0-1.2,0.5-1.2,0.9c0,0.6,0.4,0.9,1.2,1.2c1.1,0.4,1.6,0.9,1.6,1.8
                c0,1-0.7,1.8-2.2,1.8c-0.6,0-1.2-0.2-1.6-0.4L94,91.2z"/>
        </g>
        <rect x="130.5" y="58.1" class="st3" width="35.3" height="14.4"/>
        <rect x="134" y="62.3" class="st4" width="29.6" height="8.1"/>
        <text transform="matrix(1 0 0 1 133.9844 67.9833)" class="st5 st6">{{ co2 }}</text>
        <g>
            <path d="M175.8,68c-0.3,0.2-0.9,0.3-1.6,0.3c-1.8,0-3.1-1.1-3.1-3.1c0-1.9,1.3-3.3,3.2-3.3c0.8,0,1.3,0.2,1.5,0.3l-0.2,0.7
                c-0.3-0.2-0.7-0.3-1.2-0.3c-1.5,0-2.4,0.9-2.4,2.6c0,1.5,0.9,2.5,2.4,2.5c0.5,0,1-0.1,1.3-0.3L175.8,68z"/>
            <path d="M181.9,65c0,2.1-1.3,3.3-2.9,3.3c-1.6,0-2.8-1.3-2.8-3.2c0-2,1.2-3.3,2.9-3.3C180.9,61.8,181.9,63.2,181.9,65z M177.1,65.1
                c0,1.3,0.7,2.5,2,2.5c1.3,0,2-1.2,2-2.6c0-1.2-0.6-2.5-2-2.5C177.8,62.5,177.1,63.7,177.1,65.1z"/>
            <path d="M182.7,68.2v-0.5l0.6-0.6c1.5-1.5,2.2-2.2,2.2-3.1c0-0.6-0.3-1.2-1.2-1.2c-0.5,0-1,0.3-1.3,0.5l-0.3-0.6
                c0.4-0.3,1-0.6,1.7-0.6c1.3,0,1.8,0.9,1.8,1.7c0,1.1-0.8,2-2.1,3.2l-0.5,0.4v0h2.7v0.7C186.5,68.2,182.7,68.2,182.7,68.2z"/>
        </g>
        <rect x="131" y="82.5" class="st3" width="35.3" height="14.4"/>
        <rect x="134.5" y="86.7" class="st4" width="29.6" height="8.1"/>
        <text transform="matrix(1 0 0 1 134.5268 92.3772)" class="st5 st6">{{ o2 }}</text>
        <g>
            <path d="M177.4,89.4c0,2.1-1.3,3.3-2.9,3.3c-1.6,0-2.8-1.3-2.8-3.2c0-2,1.2-3.3,2.9-3.3C176.2,86.2,177.4,87.5,177.4,89.4z
                M172.5,89.5c0,1.3,0.7,2.5,2,2.5c1.3,0,2-1.2,2-2.6c0-1.2-0.6-2.5-2-2.5C173.2,86.9,172.5,88.1,172.5,89.5z"/>
            <path d="M178.1,92.6v-0.5l0.6-0.6c1.5-1.5,2.2-2.2,2.2-3.1c0-0.6-0.3-1.2-1.2-1.2c-0.5,0-1,0.3-1.3,0.5l-0.3-0.6
                c0.4-0.3,1-0.6,1.7-0.6c1.3,0,1.8,0.9,1.8,1.7c0,1.1-0.8,2-2.1,3.2l-0.5,0.4v0h2.7v0.7H178.1z"/>
        </g>
        <rect x="170.5" y="151.3" class="st4" width="15.4" height="11.8"/>
        <text transform="matrix(1 0 0 1 170.4779 159.7897)" class="st7 st8">PT</text>
        <rect x="273.6" y="151.4" class="st4" width="15.4" height="11.8"/>
        <text transform="matrix(1 0 0 1 273.5886 159.9389)" class="st7 st8">TT</text>
        <rect x="367.8" y="152" class="st4" width="15.4" height="11.8"/>
        <text transform="matrix(1 0 0 1 366.8186 159.5047)" class="st7 st8">FT</text>
        <rect x="471.3" y="35.1" class="st4" width="19.9" height="11.6"/>
        <text transform="matrix(1 0 0 1 471.2529 40.5737)" class="st7 st9">{{getOnOff()}}</text>
        <line class="st10" x1="490.3" y1="32.8" x2="490.3" y2="42.6"/>
        <rect x="499.8" y="35.1" class="st4" width="70.7" height="11.6"/>
        <text transform="matrix(1 0 0 1 497.7598 40.5737)" class="st7 st9">{{ lastModified }}</text>
        <rect x="481" y="138.3" class="st11" width="67.4" height="18.9"/>
        <rect x="484.7" y="144" class="st4" width="70.7" height="11.6"/>
        <text transform="matrix(1 0 0 1 484.6686 151.0718)" class="st7 st12">{{nietHerleid}}</text>
        </svg>

    </div>

</template>

<style scoped>

    svg text {
        font-family:'arial'; 
    }

    .st0{fill:#F6F6F6;stroke:#000000;stroke-miterlimit:10;}
	.st1{fill:#EE715C;}
	.st2{fill:#FFD25F;}
	.st3{fill:none;stroke:#000000;stroke-miterlimit:10;}
	.st4{fill:none;}
	.st5{font-family:'arial';}
	.st6{font-size:8px;}
	.st7{font-family:'arial';}
	.st8{font-size:12px;}
	.st9{font-size:7.661px;}
	.st10{fill:none;stroke:#939393;stroke-miterlimit:10;}
	.st11{fill:#FFFFFF;stroke:#000000;stroke-miterlimit:10;}
	.st12{font-size:10px;}
        
</style>

<script>

import helpers from "@/helpers";
import moment from "moment-timezone" ;

export default {
    
    data () {
        return {
            ch4: null,
            co2: null,
            h2s: null,
            o2: null,
            buffer_gas: null,
            temprature: null,
            afleverdruk: null,
            flow: null,
            flame: false,
            nietHerleid: null,
            lastModified: null
        }
    },
    props: {
        device: {
            type: Object,
            required: false,
            default: null
        },
    },
    methods: {

        getOnOff(){

            if(this.flame){
                return this.$t('On');
            }else{
                return this.$t('Off');
            }
            
        }

    },
    created() {

        var _this = this ; 

        // Get tags
        this.device.db.collection('tags').onSnapshot(function(querySnapshot) {

            querySnapshot.forEach(function(doc) {

                let tag = doc.data() ;
                tag.id = doc.id ; 

                // status
                if(tag.id == 'f702a76c09034a54993a'){
                    
                    if(tag.value == 2 || tag.value == 3){
                        _this.flame = true ;	    		
                    }else{
                        _this.flame = false ;	    		
                    }

                    _this.lastModified  = moment.unix(tag.last_updated).tz("Europe/Amsterdam").format("DD-MM-YYYY HH:mm") ;

                }

                // CH4
                if(tag.id == '7c838a7f0d264c2aa017'){

                    _this.ch4 = helpers.get_tagValue(tag, true) ;

                    // $('.visual_afleverskid_byk .ch4').text(Math.round(tag.data().value)+"%");
                }

                // CO2
                if(tag.id == '1491d9ed8b0e4993bed9'){

                    _this.co2 = helpers.get_tagValue(tag, true) ;

                    // $(".visual_afleverskid_byk .co2").text(Math.round(tag.data().value)+"%") ;

                }

                // H2S
                if(tag.id == 'f241f8afb0bc4b43884e'){

                    _this.h2s = helpers.get_tagValue(tag, true) ;


                    // $(".visual_afleverskid_byk .h2s").text(Math.round(tag.data().value)+" ppn") ;

                }

                // o2
                if(tag.id == 'f0d82cf49ad841b6a094'){
                    
                    _this.o2 = helpers.get_tagValue(tag, true) ;
                    

                    // $(".visual_afleverskid_byk .o2").text(tag.data().value+"%") ;

                }

                // Buffer gas level
                // if(tag.id == '38e443eebf3749be9251'){
                if(tag.id == 'e4bf252e8fd24967a5c5'){

                    _this.buffer_gas = helpers.get_tagValue(tag) ;

                    // $(".visual_afleverskid_byk .buffer_gas_level").text(Math.round(tag.data().value)+"%") ;

                }

                // Temprature
                if(tag.id == '57601d655fec4bada623'){

                    _this.temprature = helpers.get_tagValue(tag, true) ;


                    // $(".visual_afleverskid_byk .temprature").text(tag.data().value) ;
                }

                // PT10 Afleverdruk
                if(tag.id == '291c02d7cf7646619113'){
                    _this.afleverdruk = helpers.get_tagValue(tag, true) ;
                }

                // fedura flow
                if(tag.id == '1214157bdc7540c1824e'){

                    _this.flow = helpers.get_tagValue(tag, true) ;

                    // $(".visual_afleverskid_byk .flow").text(Math.round(tag.data().value)) ;
                }

                // nietHerleid volume
                if(tag.id == '459c98b0090640899e21'){

                    _this.nietHerleid = helpers.get_tagValue(tag, true) ;

                }


            });

        });

        

    }

}

</script>